template = require('./doc_sign.html.slim')

angular.module('wbComponents').directive('wbDocSign',
[
  '$location',
  'railsResource',
  'users',
  'analytics',
  'Agreement',
  'AccountApplication',
(
  $location,
  $resource,
  users,
  analytics,
  Agreement,
  AccountApplication,
) ->
  scope: {
    application: '=',
    container: '@'
  }
  restrict: 'E'
  replace: true
  transclude: true
  templateUrl: template
  link: (scope, $el, $attrs) ->
    scope.loading = false
    scope.agreementFail = false

    routeToCompleted = ->
      scope.application.$update(last_step: 'completed', submit: true)
      $location
        .path("/applications/#{scope.application.id}")
        .search('step', 'completed')

    unless _.includes([
      'failed',
      'incomplete',
      'submitted',
      'documents_sent'
    ], scope.application.status)
      routeToCompleted()

    goToAgreementSignature = (agreement) ->
      if !agreement || agreement.status == 'waiting' || !agreement.signatureId
        # This loop potentially waits to backend
        # 'AgreementSetup' async job to complete
        timeoutLimit = 20
        timeoutIndex = 0

        checkForAgreement = setInterval ->
          timeoutIndex++
          if timeoutIndex >= timeoutLimit
            scope.agreementFail = true
            scope.loading = false
            clearInterval checkForAgreement
          loadAgreementData()
        , 1000
      else if _.includes([
        'all_signed',
        'needs_agent',
        'needs_manager'
      ], agreement.status)
        return routeToCompleted()
      else
        location.href = agreement.signatureId

    loadAgreementData = ->
      if scope.application.agreement
        Agreement.get {
          id: scope.application.agreement.id
        }, goToAgreementSignature

    skipSigning = ->
      routeToCompleted()

    scope.sign = ->
      scope.loading = true
      goToAgreementSignature(scope.application.agreement)
])
